<template>
  <fullscreen
    background="#F3F5F7"
    class="fullscreen-tabs"
    ref="fullscreen"
    @change="fullScreenChange"
  >
    <ModalTableDescription
      v-model="descriptionModal.show"
      :description="description"
    />
    <div class="fullscreen-tabs-controls">
      <div class="fullscreen-tabs-controls-left">
        <slot name="tabsControls"></slot>
      </div>
      <div class="fullscreen-tabs-controls-right">
        <div class="table-controls-right__item">
          <a
            class="link"
            v-if="description.length"
            @click.prevent="openModalTableDescription"
          >
            Description
          </a>
        </div>
        <b-button
          class="button btn-icon"
          variant="outline-info"
          @click="toggleFullscreen"
        >
            <span class="material-icons">
              fullscreen_exit
            </span>
        </b-button>
      </div>
    </div>
    <slot name="tabsContent"></slot>
  </fullscreen>
</template>

<script>
import ModalTableDescription from '@components/modals/ModalTableDescription'

export default {
  components: {
    ModalTableDescription
  },
  props: {
    description: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      descriptionModal: {
        show: false
      }
    }
  },
  methods: {
    openModalTableDescription () {
      this.descriptionModal.show = true
    },
    toggleFullscreen () {
      this.$refs['fullscreen'].toggle()
    },
    fullScreenChange (fullscreen) {
      this.fullscreen = fullscreen
    }
  }
}
</script>

<style lang="scss">
  .fullscreen-tabs-controls{
    padding: 15px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px solid #F3F5F7;
  }
  .fullscreen-tabs-controls,
  .fullscreen-tabs-controls-left,
  .fullscreen-tabs-controls-right{
    display: flex;
    justify-content: space-between;
    background-color: #fff;
  }
  .fullscreen-tabs{
    .table-container, .table-controls{
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
  .fullscreen-tabs.fullscreen{
    padding: 10px;
  }

</style>
